import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'
import { siteQuery } from '@/queries/site.query'

export const SearchSchema = z.object({
  tab: z.union([z.literal('site'), z.literal('site-workers'), z.literal('installations'), z.literal('works')]).default('site'),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/site/$id/information/')({
  validateSearch: SearchSchema,
  beforeLoad({ context }) {
    if (!context.user?.hasPermission(Permission.SITE_INFORMATION)) {
      throw redirect({
        to: '/403',
      })
    }
  },
  loader({ params, context: { queryClient } }) {
    return queryClient.ensureQueryData(siteQuery(params.id))
  },
  pendingComponent: PendingComponent,
})
